<app-vvr-icon [dark]="true" [full]="false" [overlay]="true" [shadow]="true"></app-vvr-icon>
<div class="map-container">
    <div class="active-filters">
        @if (filterComponent.filter.deleted) {
            <div>
                Verwijderde punten
                <div (click)="filterComponent.resetFilter('deleted')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.filterTypeText) {
            <div>
                {{filterComponent.filter.filterTypeText}}
                <div (click)="filterComponent.resetType()" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.filterMaterialText) {
            <div>
                {{filterComponent.filter.filterMaterialText}}
                <div (click)="filterComponent.resetMaterial()" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.filterPaintColorText) {
            <div>
                {{filterComponent.filter.filterPaintColorText}}
                <div (click)="filterComponent.resetPaintColor()" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.filterCrowText) {
            <div>
                {{filterComponent.filter.filterCrowText}}
                <div (click)="filterComponent.resetCrow()" class="close"></div>
            </div>
        }
        @if (!nearby && selectionComponent && !selectionComponent.selectionVisible()) {
            @if (filterComponent.filter.enabledStatusText || filterComponent.filter.disabledStatusText) {
                <div>
                    Status: {{filterComponent.filter.enabledStatusText}}
                    @if (filterComponent.filter.enabledStatusText && filterComponent.filter.disabledStatusText) {
                        ,
                    }
                    <del>{{filterComponent.filter.disabledStatusText}}</del>
                    <div (click)="filterComponent.resetStatus()" class="close"></div>
                </div>
            }
        }
        @if (filterComponent.filter.with_comment) {
            <div>
                Met opmerking
                <div (click)="filterComponent.resetFilter('with_comment')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.priority_figuration) {
            <div>
                Voorrang figuraties
                <div (click)="filterComponent.resetFilter('priority_figuration')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.always_check) {
            <div>
                Altijd controleren
                <div (click)="filterComponent.resetFilter('always_check')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.primer) {
            <div>
                Primer
                <div (click)="filterComponent.resetFilter('primer')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.blast) {
            <div>
                Stralen
                <div (click)="filterComponent.resetFilter('blast')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.stake_out) {
            <div>
                Uitzetten
                <div (click)="filterComponent.resetFilter('stake_out')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.turbo_burn) {
            <div>
                Turbo branden
                <div (click)="filterComponent.resetFilter('turbo_burn')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.manual_burn) {
            <div>
                Handmatig branden
                <div (click)="filterComponent.resetFilter('manual_burn')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.day) {
            <div>
                Dag
                <div (click)="filterComponent.resetFilter('day')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.night) {
            <div>
                Nacht
                <div (click)="filterComponent.resetFilter('night')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.exclusive_material) {
            <div>
                Zonder materiaal
                <div (click)="filterComponent.resetFilter('exclusive_material')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.overgrown) {
            <div>
                Overgroeide kanten
                <div (click)="filterComponent.resetFilter('overgrown')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.traffic_controllers) {
            <div>
                Verkeersregelaars
                <div (click)="filterComponent.resetFilter('traffic_controllers')" class="close"></div>
            </div>
        }
        @if (filterComponent.filter.no_traffic_controllers) {
            <div>
                Geen verkeersregelaars
                <div (click)="filterComponent.resetFilter('no_traffic_controllers')" class="close"></div>
            </div>
        }
    </div>
    @if (showPriceSelectionBar && selectionComponent) {
        <div
            [class.disable]="selectionComponent.selectionVisible()"
            [class.opened]="selectionComponent.selectionVisible() || pushpinMoveComponent?.visible"
            [class.ps-0]="pushpinMoveComponent?.visible"
            class="controls-top left">
            @if (!manualAreasComponent.manualAreasMode() && !pushpinMoveComponent?.visible) {
                <div (click)="selectionComponent.toggleSelection()"
                     [class.active]="selectionComponent.selectionVisible()"
                     class="fab small"
                     id="btn-selection-open"
                     matTooltip="Prijs en statusbalk"
                     matTooltipPosition="after">
                    @if (selectionComponent.selectionVisible()) {
                        <i class="fas fa-times"></i>
                    }
                    @if (!selectionComponent.selectionVisible()) {
                        <i class="fas fa-shopping-cart"></i>
                    }
                </div>
            }
            @if (!manualAreasComponent.manualAreasMode() && !selectionComponent.selectionVisible() && AuthorisationService.hasFeature('inspectionSave')) {
                <div (click)="pushpinMoveComponent.toggle()" [class.active]="pushpinMoveComponent?.visible"
                     class="fab small"
                     id="btn-move-inspection"
                     matTooltip="Verplaatsen of kopiëren van Schouwronde"
                     matTooltipPosition="after">
                    <i [class.fa-times]="pushpinMoveComponent?.visible" class="fas fa-dolly"></i>
                </div>
            }
        </div>
    }
    @if (!nearby && !showPriceSelectionBar) {
        <div (click)="chooseInspection.emit()" [class.map-style-road]="mapStyleRoad" class="controls-top left statustext">
            Status: {{inspection()?.inspection_status?.name}}
        </div>
    }

    @if (filterComponent.filterVisible()) {
        <div (click)="toggleFilter()" class="filter-overlay"></div>
    }
    <div [class.disable]="filterComponent.filterVisible()" [class.opened]="filterComponent.filterVisible() || manualAreasComponent.manualAreasMode()" class="controls-top">
        @if (!manualAreasComponent.manualAreasMode()) {
            <div
                (click)="toggleFilter()"
                [class.active]="filterComponent.filterVisible()"
                [matBadge]="filterComponent.filter.filterCount"
                class="fab small"
                id="btn-filters"
                matBadgePosition="above before"
                matTooltip="Filters"
                matTooltipPosition="before">
                @if (filterComponent.filterVisible()) {
                    <i class="fas fa-times"></i>
                }
                @if (!filterComponent.filterVisible()) {
                    <i class="fas fa-filter"></i>
                }
            </div>
        }
        @if (manualAreasComponent.manualAreasMode()) {
            <div (click)="manualAreasComponent.closeManualAreasDialog()"
                 class="fab small active" id="btn-manualAreas-exit" matTooltip="Sluit gemarkeerde gebieden en straten" matTooltipPosition="before">
                <i class="fas fa-times"></i>
            </div>
        }
        <div (click)="back()" class="fab small" id="btn-Exit" matTooltip="Terug naar overzicht" matTooltipPosition="before">
            <i class="fas fa-sign-out-alt"></i>
        </div>
        <div id="btn-searchLocation">
            <div (click)="openAddressSearch($event)" class="fab small" matTooltip="Zoeken op kaart" matTooltipPosition="before">
                <i class="fas fa-search"></i>
            </div>
            <div [class.visible]="isSearching" class="searchbar">
                <mat-form-field>
                    <mat-label>Zoek een adres</mat-label>
                    <input #searchInput="matInput" [formControl]="addressAutocomplete" [matAutocomplete]="auto" matInput type="text">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="goToAddress($event)" [displayWith]="showAddress" autoActiveFirstOption class="address-list">
                        @for (item of addressSearch | async; track item.name) {
                            <mat-option [value]="item">
                                {{item.name}}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-icon-button (click)="clearHecto()" matTooltip="Hectometer markeringen op kaart wissen" matTooltipPosition="before">
                    <mat-icon class="fas fa-eraser"></mat-icon>
                </button>
            </div>
        </div>

        @if (!manualAreasComponent?.manualAreasMode() && !filterComponent?.filterVisible() && AuthorisationService?.hasFeature('manualAreasSave')) {
            <div
                (click)="manualAreasComponent.openManualAreasDialog()"
                class="fab small d-none d-md-block"
                id="btn-manualAreas"
                matTooltip="Gemarkeerde gebieden en straten"
                matTooltipPosition="before">
                <i class="fas fa-draw-polygon"></i>
            </div>
        }
        <div (click)="toggleMapStyle()" class="fab small" id="btn-toggleMapStyle" matTooltip="Wissel kaart/satelliet" matTooltipPosition="before">
            <i class="fas fa-layer-group"></i>
        </div>
        <div (click)="centerTown()" class="fab small" id="btn-centerTown" matTooltip="Centreer op klantgebied" matTooltipPosition="before">
            <i class="area-icon"></i>
        </div>
        <div (click)="centerGps()" class="fab small" id="btn-currentLocation" matTooltip="Centreer op GPS locatie" matTooltipPosition="before">
            @if (followLocation) {
                <i class="fas fa-location-arrow"></i>
            }
            @if (!followLocation) {
                <i class="fa-light fa-location-arrow"></i>
            }
        </div>
    </div>
    <div [class.disable]="filterComponent?.filterVisible()" [class.opened]="filterComponent.filterVisible() || manualAreasComponent.manualAreasMode()" class="controls-bottom">
        @if (!manualAreasComponent?.manualAreasMode()) {
            <div
                [routerLink]="['/pushpins/list/', customerArea()?.id ?? 'nearby', mapZoom(), mapCenter()?.lat, mapCenter()?.lng, {inspection: inspection()?.id}]"
                class="fab big"
                id="btn-Listview"
                matTooltip="Lijstweergave"
                matTooltipPosition="before">
                <i class="fas fa-list-ul"></i>
            </div>
        }
        @if (lengthMarkDraft?.draft) {
            <div
                (click)="deleteDraftPushpin()"
                class="fab big"
                matTooltip="{{lengthMarkDraft?.end_lat ? 'Annuleer correctie van deze lengtemarkering' : 'Verwijder deze lengtemarkering'}}"
                matTooltipPosition="before">
                @if (!lengthMarkDraft?.end_lat) {
                    <i class="fas fa-trash"></i>
                }
                @if (lengthMarkDraft?.end_lat) {
                    <i class="fa-solid fa-rotate-left"></i>
                }
            </div>
        }
        @if (lengthMarkDraft) {
            <div
                (click)="navigateDraftPushpin()"
                [class.disabled]="distanceDraftLengthMark() < 1"
                class="fab big secondary"
                id="btn-finalizePin"
                matTooltip="Item toevoegen"
                matTooltipPosition="before">
                <i class="fas fa-check"></i>
            </div>
        }
        @if (!nearby && !manualAreasComponent?.manualAreasMode() && showAddPinButton && AuthorisationService.hasFeature('pushpinSave')) {
            <div
                (click)="navigateToPushpin()"
                [class.disabled-events]="!inspection() || inspection()?.lock"
                class="fab big primary"
                id="btn-addPin"
                matTooltip="Item toevoegen"
                matTooltipPosition="before">
                <i class="fas fa-plus"></i>
            </div>
        }
        @if (manualAreasComponent.manualAreasMode() && manualAreasComponent.manualAreaDrawing() && isCordova) {
            <div
                (click)="manualAreasComponent.setPoint()"
                class="fab big primary"
                id="btn-addMan"
                matTooltip="Punt toevoegen"
                matTooltipPosition="before">
                <i class="fas fa-check"></i>
            </div>
        }
    </div>
    <div [class.roadstyle]="mapStyleRoad" class="crosshair"></div>
    <google-map
        #map
        (mapClick)="onMapClick($event)"
        (mapRightclick)="onMapRightClick($event)"
        [center]="mapCenter()"
        [height]="'100%'"
        [mapTypeId]="mapTypeId()"
        [options]="mapOptions()"
        [width]="'100%'"
        [zoom]="mapZoom()">

        @if (selectionPolygon()) {
            @for (point of selectionPolygon(); track point; let i = $index) {
                <map-advanced-marker
                    (mapClick)="removePointFromSelectionPolygon($event, i)"
                    (mapDragend)="changeSelectionPolygon($event, i)"
                    [options]="{zIndex: 10, draggable: true}"
                    [position]="point">
                </map-advanced-marker>
            }
            @if (selectionPolygon()?.length > 1) {
                <map-polygon
                    [options]="{strokeColor: '#ffdd00', zIndex: 10, fillColor: '#ffdd00', fillOpacity: 0.05}"
                    [paths]="selectionPolygon()">
                </map-polygon>
            }
        }

        @if (customerArea()?.area?.length) {
            <map-polygon
                [options]="{
                         strokeColor: '#e30613',
                         strokeWeight: 2,
                         fillColor: '#e30613',
                         fillOpacity: map.getZoom() < Settings.ZOOMLEVEL_TRESHOLD_FILLCOLOR ? 0.08 : 0,  clickable: false
                         }"
                [paths]="customerArea()?.area">
            </map-polygon>
        }
        @if (hectoPins) {
            @for (hectoPin of hectoPins; track hectoPin) {
                <map-advanced-marker
                    [content]="hectoPin | hectoPinIcon"
                    [options]="{zIndex: 3}"
                    [position]="{lat: +hectoPin.lat, lng: +hectoPin.lng}">
                </map-advanced-marker>
            }
        }
        @for (pushpin of pushpins(); track pushpin.id) {
            @if (!pushpin.lengthmark) {
                <map-advanced-marker
                    [content]="pushpin | pushpinIcon:mapStyleRoad"
                    [options]="{zIndex: 3}"
                    [position]="{lat: +pushpin.lat, lng: +pushpin.lng}">
                </map-advanced-marker>
            }
            @if (pushpin.lengthmark) {
                @if (pushpin.snappedpoints && pushpin.snappedpoints.snappedPoints && pushpin.snappedpoints.snappedPoints.length > 1) {
                    <map-polyline
                        [options]="{strokeColor: '#' + (pushpin | polylineColor), strokeWeight: 2, zIndex: 3, clickable: false}"
                        [path]="pushpin | polylinePath">
                    </map-polyline>
                }
                @if (pushpin.snappedpoints?.snappedPoints?.length > 1) {
                    <map-advanced-marker
                        [content]="pushpin | pushpinIcon:mapStyleRoad"
                        [options]="{zIndex: 3}"
                        [position]="(pushpin | polylinePath)[0]">
                    </map-advanced-marker>
                    <map-advanced-marker
                        [content]="pushpin | pushpinIcon:mapStyleRoad"
                        [options]="{zIndex: 3}"
                        [position]="(pushpin | polylinePath)[pushpin.snappedpoints.snappedPoints?.length - 1]">
                    </map-advanced-marker>
                }
            }
        }
        @if (manualAreasComponent?.areas()?.length) {
            @for (area of manualAreasComponent.areas(); track area) {
                @if (!area.drawing && !area.isGeoJson) {
                    <map-polygon
                        [options]="{strokeColor: area.strokeColor || '#000', strokeWeight: 2, fillColor: area.fillColor || '#ff0000', fillOpacity: 0.4, zIndex: 2, clickable: false}"
                        [paths]="area.isStreet ? area.snappedPoints : area.exteriorRing">
                    </map-polygon>
                }
            }
        }

        @if (manualAreasComponent.drawingArea()) {
            @if (manualAreasComponent.drawingArea().exteriorRing?.length) {
                @for (point of manualAreasComponent.drawingArea().exteriorRing; track point; let i = $index) {
                    <map-advanced-marker
                        (mapDragend)="changeDrawingArea($event, i)"
                        [options]="{zIndex: 3, draggable: !manualAreasComponent.drawingArea().isStreet}"
                        [position]="{lat: +point.lat, lng: +point.lng}">
                    </map-advanced-marker>
                }
            }
            <map-polygon
                [options]="{strokeColor: manualAreasComponent.drawingArea().strokeColor || '#000', strokeWeight: 2, fillColor: manualAreasComponent.drawingArea().fillColor || '#ff0000', fillOpacity: 0.4, zIndex: 2}"
                [paths]="manualAreasComponent.drawingArea()?.isStreet ? manualAreasComponent.drawingArea().snappedPoints : manualAreasComponent.drawingArea().exteriorRing">
            </map-polygon>
        }
        @if (draftPolyLine) {
            <map-polyline [options]="{strokeColor: '#ffdd00', strokeWeight:4, zIndex: 3}" [path]="draftPolyLine"></map-polyline>
        }
        @if (showRoutePoints) {
            @for (rPoint of routePoints; track rPoint) {
                <map-advanced-marker [options]="{zIndex: 8}" [position]="{lat: +rPoint.lat, lng: +rPoint.lng}"></map-advanced-marker>
            }
        }
        @if (gpsLocation) {
            <map-advanced-marker [content]="locationPinIcon" [options]="{zIndex: 3}" [position]="gpsLocation"></map-advanced-marker>
        }
    </google-map>
</div>
@if (selectedPosition && selectedPushpins().length) {
    <div
        [style.bottom]="selectedPosition.bottom"
        [style.left]="selectedPosition.left"
        [style.right]="selectedPosition.right"
        [style.top]="selectedPosition.top"
        class="pushpin-preview">
        <div [style.max-height]="selectedPosition.maxHeight" class="pin-wrapper">
            <div class="dialog-close">
                <div (click)="selectedPushpins.set([])" class="fab small active" id="btn-cancel" matTooltip="Sluiten" matTooltipPosition="after">
                    <i class="fas fa-times"></i>
                </div>
            </div>
            @for (pushpin of selectedPushpins(); track pushpin.id) {
                <div class="pin">
                    <h1 (click)="openPushpin(pushpin)" class="h4 condensed">Punaise {{pushpin.number}}</h1>
                    <div class="materials">
                        @for (mat of pushpin.material_surfaces; track mat.id) {
                            <div class="material-surface">
                                {{mat.material}}: {{mat.surface | number:'1.0-2'}} m<sup>{{pushpin.lengthmark ? '1' : '2'}}</sup>
                            </div>
                        }
                    </div>
                    @for (part of pushpin.pushpin_parts; track part) {
                        <div (click)="openPushpin(pushpin, part.id)" class="part">
                            <span class="material">
                                {{part.material.name}}
                                {{part.primer ? ' + primer' : ''}}
                            </span>
                            <b>
                                {{part.decoration?.decoration_group}}
                            </b><br>
                            <div [style.color]="'#' + part?.status?.color" class="status">
                                {{part.status?.name}}
                            </div>
                            @if (part.decoration?.specify_length) {
                                {{part.length | number:'1.0-2'}}m<sup>1</sup> {{part.decoration?.name}}
                            }
                            @if (!part.decoration?.specify_length) {
                                {{part.amount}} * {{part.decoration?.name}}
                            }
                            @if (part.status_id === 9) {
                                <div>
                                    Uitgevoerd op {{part['executedDate'] | date : 'd MMM yyyy, H:mm'}}
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
@if (lengthMarkDraft) {
    <div class="length-mark">
        <h3 class="h6 condensed">Lengtemarkering invoeren</h3>
        <div class="distance">
            Huidige lengte: {{!loadingSnappedPoints ? (distanceDraftLengthMark() | number) + 'm' : 'Wordt berekend...'}}
            @if (loadingSnappedPoints) {
                <i class="fas fa-spinner fa-spin"></i>
            }
        </div>
        <div class="explain">
            <p>Versleep de kaart naar het eindpunt en klik op het gele vinkje. Na het opslaan kun je de lijn corrigeren.</p>
            <p>Je kunt tussendoor gewoon punaises aanmaken en het eindpunt later opslaan.</p>
        </div>
        @if (lengthMarkDraft && !distanceDraftLengthMark()) {
            <div class="error">
                Sleep het midden van de kaart op een weg om de afstand te berekenen
            </div>
        }
        @if (nonRoadline) {
            <div class="error">
                Lengtemarkering kon niet op een bestaande weg worden getekend
            </div>
        }
        <div>
            <mat-checkbox (ngModelChange)="drawDraftLengthmark()" [(ngModel)]="lengthMarkUseRoute" class="d-block">
                Tekenen volgens afgelegde route
            </mat-checkbox>
            <mat-checkbox (ngModelChange)="drawDraftLengthmark()" [(ngModel)]="travelModeWalking" class="d-block">
                Dit is een fiets/wandel pad
            </mat-checkbox>
        </div>
    </div>
}
@if (!googleMap) {
    <app-loading text='Momentje, de kaart wordt geladen...'></app-loading>
}
